var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"activity-description-container"},[_c('div',{staticClass:"good-introduce",domProps:{"innerHTML":_vm._s(_vm.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }